// extracted by mini-css-extract-plugin
export var container = "_cu-0";
export var infoIcon = "_cu-2";
export var titleRowCol = "_cu-1";